import { loginUser } from '@/store/thunks/LoginUser';
import { User } from '@/models/User';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserStoreState {
  currentUser: User | null;
}

const initialState: UserStoreState = {
  currentUser: null,
};

const getCurrentUserReducer = (state: UserStoreState): User | null =>
  state.currentUser;

export const setCurrentUserReducer = (
  state: UserStoreState,
  action: PayloadAction<User | null>,
): void => {
  state.currentUser = action.payload;
};

export const userStoreSlice = createSlice({
  name: 'userStore',
  initialState,
  reducers: {
    setCurrentUser: setCurrentUserReducer,
  },
  extraReducers: (builder) => {
    builder.addCase(loginUser.fulfilled, setCurrentUserReducer);
  },
  selectors: {
    getCurrentUser: getCurrentUserReducer,
  },
});

export const { setCurrentUser } = userStoreSlice.actions;
export const { getCurrentUser } = userStoreSlice.selectors;
export const userStoreReducer = userStoreSlice.reducer;
